import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

const normalizeList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.rows)) {
    return payload.rows;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  return [];
};

const normalizeMainRow = (row, index) => ({
  ...row,
  daysLeftToApprovePriority: row.prioritySlaDaysRemaining ?? row.daysLeftToApprovePriority ?? row.priorityDaysLeft,
  daysLeftToApproveRegular: row.regularSlaDaysRemaining ?? row.daysLeftToApproveRegular ?? row.regularDaysLeft,
  lastDateToApprove: row.lastDateToApprove ?? row.lastApprovalDate ?? row.lastDate ?? row.approvalDate ?? null,
  id: row.id || row.detailId || `${row.batchId || "dc-cost-main"}-${index}`,
});

export const normalizeDCCostMainRows = (payload) => {
  const rows = normalizeList(payload);

  if (!rows.length) {
    return [];
  }

  return rows.map((row, index) => normalizeMainRow(row, index));
};

export const getDCCostMainRows = async () => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcCostMain}`;
  const response = await getAPI(apiUrl, tokenInfo);

  if (response.ok) {
    const payload = await response.json().catch(() => []);
    return normalizeDCCostMainRows(payload);
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to load DC cost main data.", { contactSupport: false });
  return [];
};

export default getDCCostMainRows;
